import { render, staticRenderFns } from "./tab1.vue?vue&type=template&id=76b4b547&scoped=true"
import script from "./tab1.vue?vue&type=script&lang=js"
export * from "./tab1.vue?vue&type=script&lang=js"
import style0 from "./tab1.vue?vue&type=style&index=0&id=76b4b547&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b4b547",
  null
  
)

export default component.exports